export const SCROLL_ANCHOR = 'scrollAnchor';
export const MAIN = 'main';
export const ADULTS = 'adults';
export const KIDS = 'kids';
export const YEAR_OF_MAJORITY = 18;
export const MAX_AGE = 100;
// CGUs IDs
export const CNIL_LEGAL_MESSAGE_ID = 'CNIL';
export const CGU_2_ID = 'CGU_2';
export const GENERAL_PERSONAL_INFORMATION = 'GENERAL_PERSONAL_INFORMATION';
export const UNIQUE_IDENTIFICATION_INFORMATION = 'UNIQUE_IDENTIFICATION_INFORMATION';
export const THIRD_PARTY_PROVISION = 'THIRD_PARTY_PROVISION';
export const OVERSEAS_PROVISION = 'OVERSEAS_PROVISION';
export const OVERSEAS_PROVISION_INSURANCE = 'OVERSEAS_PROVISION_INSURANCE';
export const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
export const CLUBMED_PLUS = 'CLUBMED_PLUS';
export const WHATSAPP = 'WHATSAPP';
export const PROFILING = 'PROFILING';
export const CGU_2 = 'CGU_2';
export const EMAIL = 'EMAIL';
export const SMS = 'SMS';
export const PHONE = 'PHONE';
export const MAIL = 'MAIL';
export const ALL = 'ALL';
export const WECHAT = 'WECHAT';

export const ACCEPTED_CGUS = [
  CNIL_LEGAL_MESSAGE_ID,
  CGU_2_ID,
  GENERAL_PERSONAL_INFORMATION,
  UNIQUE_IDENTIFICATION_INFORMATION,
  THIRD_PARTY_PROVISION,
  OVERSEAS_PROVISION,
  OVERSEAS_PROVISION_INSURANCE,
];
export const CGUS_ACCEPTED_BY_API = [
  EMAIL,
  SMS,
  WECHAT,
  PHONE,
  MAIL,
  ALL,
  FOSUN_PARTNERS,
  CLUBMED_PLUS,
  WHATSAPP,
  PROFILING,
  CGU_2,
];

export const WRONG_SALESMAN_ID = 'WRONG_SALESMAN_ID';
export const SALESMAN_ID_WARNING_MESSAGE = 'SALESMAN_ID_WARNING_MESSAGE';

export const ADDRESS_FIELDS_CLASSES = {
  streetName: 'sm:w-3/4',
  streetNumber: 'w-1/2 sm:w-1/4',
  zipCode: 'w-1/2 sm:w-1/3',
  city: 'sm:w-2/3',
};

export const FORM_ERROR_OBJECT = {
  0: 'birthdate',
  1: 'city',
  2: 'email',
  3: 'firstName',
  4: 'lastName',
  5: 'mobile',
  6: 'streetName',
  7: 'streetNumber',
  8: 'zipCode',
  9: 'documentNumber',
  10: 'issuingDate',
  11: 'issuingCountry',
  12: 'unicodeFirstName',
  13: 'unicodeLastName',
};
